import { render, staticRenderFns } from "./CloneTemplateRepository.vue?vue&type=template&id=5b9335bd&lang=pug"
import script from "./CloneTemplateRepository.vue?vue&type=script&lang=js"
export * from "./CloneTemplateRepository.vue?vue&type=script&lang=js"
import style0 from "./CloneTemplateRepository.vue?vue&type=style&index=0&id=5b9335bd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports